import React from 'react'

import { Box, Text, Color, AlignItems, TextAlign, GridDisplay } from '@gousto-internal/citrus-react'

import { TableRowContainer } from './Containers.styled'
import { largeGapGridTemplateColumns, smallGapGridTemplateColumns } from './constants'

type TableHeaderCellProps = {
  title: string
}

const TableHeaderCell = ({ title }: TableHeaderCellProps) => (
  <Box role="columnheader">
    <Text size={2} textAlign={TextAlign.Right}>
      {title}
    </Text>
  </Box>
)

export const AccordionTableHeader = () => (
  <TableRowContainer
    display={GridDisplay.Grid}
    color={Color.NeutralGrey_900}
    alignItems={AlignItems.FlexEnd}
    paddingBottom={1}
    paddingH={3}
    gridTemplateColumns={[smallGapGridTemplateColumns, null, largeGapGridTemplateColumns]}
  >
    <TableHeaderCell title="" />
    <TableHeaderCell title="Per box" />
    <TableHeaderCell title="Per portion" />
  </TableRowContainer>
)
